import React from 'react';
import { Link, Outlet } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import CenterLoadingSpinner from '../../components/LoadingSpinner/CenterLoadingSpinner';
import { useBrandContext } from '../../contexts/BrandContext';
import { useAPI } from '../../libs/libAPI';
import { getIconForService } from '../../libs/libIcon';
import { sortStringByIgnoreCase } from '../../libs/utils';
import { WDProductSchema } from '../../types/WDProduct';

const DataSheets: React.FC = () => {
  const api = useAPI();
  const brandContext = useBrandContext();

  const availableApps = brandContext.brand.apps ?? [];

  const productsQuery = useQuery(['products'], async () => {
    const response = await api.fetch(`${import.meta.env.VITE_API_URI}/v1/product-catalog/apps`, { method: 'GET' });

    const products = await WDProductSchema.array().parseAsync(await response.json());

    const apps = products.filter(p => p.showInCatalog).sort(sortStringByIgnoreCase('name'));

    const filteredApps = availableApps.length === 0 ? apps : apps.filter((a) => availableApps.includes(a.name));

    return filteredApps;
  });

  if (productsQuery.data == null) return <CenterLoadingSpinner />;

  return <>
    <div>
      <div className='max-w-[100vw]  py-4 md:py-12 px-12 xl:px--0 3xl:max-w-screen-2xl 2xl:max-w-screen-xl xl:max-w-screen-lg mx-auto'>
        <div>
          <h2 className='text-2xl mt-4 mb-8'>DataSheets</h2>
        </div>
        <div className='flex flex-wrap w-full'>
          {productsQuery.data.map((app) => (
            <Link key={app.name} to={`${app.name}`} className='w-full md:w-1/3 xl:w-1/4 2xl:w-1/6'>
              <div className={`mx-2 my-4 bg-background2 rounded-xl h-32 py-4 px-4 shadow shadow-background2-darker ${app.hasDatasheet ? 'border border-primary' : ''}`}>
                <div className='flex'>
                  <div>
                    {getIconForService(app.name, 'text-3xl', 'h-8 w-8')}
                  </div>
                  <div className='pl-3 my-auto'>{app.name}</div>
                </div>
                <div className='pt-3 opacity-80 text-sm'>
                  {app.description}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
    <Outlet />
  </>;
};

export default DataSheets;
